<template>
  <label for="" class="font-bold text-gray-700 block mb-2 text-sm dark:text-white">{{ label }}</label>

  <div class="relative">
    <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
      <slot>
        <svg
          class="w-4 h-4 text-gray-500 dark:text-gray-400"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 16"
        >
          <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
          <path
            d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z"
          />
        </svg>
      </slot>
    </div>

    <input
      :type="type"
      class="bg-zinc-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      :autofocus="autofocus"
      :required="required"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :minlength="minlength"
      :maxlength="maxlength"
      :value="modelValue"
      @input="updateValue"
    />
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      modelValue: string
      min?: number
      max?: number
      minlength?: number
      maxlength?: number
      type?: string
      label?: string
      autofocus?: boolean
      required?: boolean
      placeholder?: string
    }>(),
    {
      type: 'text',
      autofocus: false,
      required: false,
      min: undefined,
      max: undefined,
      minlength: undefined,
      maxlength: undefined,
      label: '',
      placeholder: '',
    },
  )

  const emit = defineEmits(['update:modelValue'])

  const updateValue = (event: Event) => {
    emit('update:modelValue', (event.target as HTMLInputElement).value)
  }
</script>
